import { hashBrowserPushEndpoint } from "@/lib/web-push-browser";
import { loadWebPushRecoveryClient } from "@/lib/webPushRecoveryClient";

async function ownedBrowserId(
  subscription: PushSubscription | null | undefined,
  savedId: string | undefined,
) {
  const current = subscription
    ? await client.notifications.getWebPushState({
        endpointHash: await hashBrowserPushEndpoint(subscription.endpoint),
      })
    : null;
  if (current?.currentSubscriptionId) return current.currentSubscriptionId;
  if (!savedId) return null;
  const saved = await client.notifications.getWebPushState({ subscriptionId: savedId });
  return saved.currentSubscriptionId;
}
import { client } from "@/utils/orpc.client";

/** Detaches the owned browser before explicit logout; leaves granted browser permission intact. */
export async function detachCurrentBrowserPush() {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  const recovery = await loadWebPushRecoveryClient();
  const local = await recovery.readState();
  await recovery.setLocalStop("detached");
  const registration = await navigator.serviceWorker.getRegistration("/");
  const subscription = await registration?.pushManager.getSubscription();
  const subscriptionId = await ownedBrowserId(subscription, local.confirmed?.subscriptionId);
  if (!subscriptionId) return;
  const result = await client.notifications.detachCurrentWebPush({ subscriptionId });
  if (!result.detached) throw new Error("Browser Push logout is incomplete");
}
